'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
var objectWithoutProperties = require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
var styles_breakpoints = require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
var components_NuDSProvider_NuDSProvider = require('../NuDSProvider/NuDSProvider.js');
var utils_isType_isType = require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
var components_Icon_Icon = require('../../Icon-efcd1bee.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
var components_Typography_Typography = require('../Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var backgroundLinearGradient = function backgroundLinearGradient(color, colorVariant) {
  return styled.css(["background-image:linear-gradient(120deg,", " 0%,", " 100%),linear-gradient(120deg,transparent,transparent);"], styles_themeUtils.nuDSColor(color, colorVariant), styles_themeUtils.nuDSColor(color, colorVariant));
};

var underlineEffect = function underlineEffect(color, colorVariant) {
  return styled.css(["background-repeat:no-repeat;background-position:0 100%,100% 100%;background-size:0 8%,100% 8%;transition:background-size 0.2s ease-in-out;", ";&:hover,&:focus{text-decoration:none;background-size:100% 8%,100% 8%;}"], backgroundLinearGradient(color, colorVariant));
};

var variantMapStyle = {
  action: styled.css(["line-height:1.35;display:inline-flex;align-items:center;", ";"], function (_ref) {
    var color = _ref.color,
        colorVariant = _ref.colorVariant;
    return underlineEffect(color, colorVariant);
  }),
  text: styled.css(["&:hover{text-decoration:underline;}&:focus{text-decoration:none;outline-width:2px;outline-style:solid;outline-color:", ";}"], function (_ref2) {
    var color = _ref2.color,
        colorVariant = _ref2.colorVariant;
    return styles_themeUtils.nuDSColor(color, colorVariant);
  })
};
var StyledTypography = styled__default['default'](components_Typography_Typography['default']).withConfig({
  displayName: "BaseLink__StyledTypography",
  componentId: "etrcfn-0"
})(["text-decoration:none;", ";"], function (_ref3) {
  var linkVariant = _ref3.linkVariant;
  return variantMapStyle[linkVariant] ? variantMapStyle[linkVariant] : variantMapStyle.text;
});
StyledTypography.displayName = 'StyledTypography';
var UnstyledLink = styled__default['default'].a.withConfig({
  displayName: "BaseLink__UnstyledLink",
  componentId: "etrcfn-1"
})([""]);
UnstyledLink.displayName = 'UnstyledLink';

var StyledIcon = styled__default['default'](components_Icon_Icon.Icon).withConfig({
  displayName: "StyledIcon",
  componentId: "sc-1d6qvbo-0"
})(["margin:0 0 0 0.5rem;"]);

var variantMapper = {
  text: 'paragraph1',
  action: 'action'
};
var colorMapper = {
  primary: {
    color: 'primary.default'
  },
  primaryLight: {
    color: 'primary.light'
  },
  white: {
    color: 'white.default'
  }
};
var linkVariantsPropType = index.propTypes.oneOf(Object.keys(variantMapper));
var linkColorsPropType = index.propTypes.oneOf([].concat(styles_breakpoints.toConsumableArray(Object.keys(colorMapper)), ['inherit', 'initial']));

function renderActionIcons(variant) {
  var isExternal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var canRender = variant === 'action';
  var iconName = isExternal ? 'arrow-up-right' : 'arrow-right';
  var titleName = isExternal ? 'External Link' : 'Internal Link';
  return canRender && /*#__PURE__*/React__default['default'].createElement(StyledIcon, {
    size: "small",
    title: titleName,
    name: iconName
  });
}

var GROUP_TO_PUT_SLASH = /\/?(\?|#|$)/;

function addSlashAtEnd(href) {
  return "".concat(href.replace(GROUP_TO_PUT_SLASH, '/$1'));
}

var Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      variant = props.variant,
      color = props.color,
      href = props.href,
      iconProps = props.iconProps,
      intlKey = props.intlKey,
      intlValues = props.intlValues,
      rel = props.rel,
      target = props.target,
      typographyProps = props.typographyProps,
      noStyle = props.noStyle,
      rest = objectWithoutProperties.objectWithoutProperties(props, ["children", "variant", "color", "href", "iconProps", "intlKey", "intlValues", "rel", "target", "typographyProps", "noStyle"]);

  var _useContext = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext),
      formatMessage = _useContext.formatMessage,
      RouterLinkComponent = _useContext.routerLinkComponent;

  var isExternalURL = !href.startsWith('/');
  var isAnchor = href.startsWith('#');
  var normalizedHref = !isAnchor && !isExternalURL ? addSlashAtEnd(href) : href;
  var typographyVariant = variantMapper[variant];
  var typographyColor = colorMapper[color];
  var componentChildren = intlKey ? formatMessage({
    id: intlKey
  }, intlValues) : children;
  var LinkComponent = noStyle ? UnstyledLink : StyledTypography;

  var linkProps = _extends._extends_1({
    linkVariant: variant,
    variant: typographyVariant,
    colorLink: color
  }, typographyColor);

  var attrsProps = _extends._extends_1({}, linkProps, typographyProps, {
    noStyle: noStyle,
    ref: ref
  });

  if (utils_isType_isType.isType('undefined', target) && isExternalURL && !isAnchor) {
    var externalProps = {
      target: '_blank',
      rel: 'noopener'
    };
    attrsProps = _extends._extends_1({}, externalProps, attrsProps);
  }

  if (target) {
    if (target === '_blank') {
      attrsProps = _extends._extends_1({}, attrsProps, {
        target: target,
        rel: 'noopener'
      });
    }

    attrsProps = _extends._extends_1({}, attrsProps, {
      target: target
    });
  }

  if (rel) {
    attrsProps = _extends._extends_1({}, attrsProps, {
      rel: rel
    });
  }

  var iconComponent = Object.keys(iconProps).length ? /*#__PURE__*/React__default['default'].createElement(StyledIcon, {
    size: iconProps.size,
    title: iconProps.title,
    name: iconProps.name
  }) : renderActionIcons(variant, isExternalURL);
  var hasRouterLink = Boolean(RouterLinkComponent);

  if (!isExternalURL && hasRouterLink) {
    return /*#__PURE__*/React__default['default'].createElement(RouterLinkComponent, _extends._extends_1({
      tag: "a",
      href: normalizedHref
    }, attrsProps, rest, {
      linkComponent: LinkComponent
    }), componentChildren, iconComponent);
  }

  return /*#__PURE__*/React__default['default'].createElement(LinkComponent, _extends._extends_1({
    tag: "a",
    href: normalizedHref
  }, attrsProps, rest), componentChildren, iconComponent);
});
Link.defaultProps = {
  children: undefined,
  className: null,
  color: 'primary',
  hrefLang: undefined,
  intlKey: null,
  intlValues: {},
  noStyle: false,
  variant: 'text',
  target: undefined,
  rel: undefined,
  typographyProps: {},
  iconProps: {}
};
Link.propTypes = {
  children: index.propTypes.node,
  className: index.propTypes.string,

  /** The color styles that will be rendered */
  color: linkColorsPropType,

  /** The URL that will be rendered */
  href: index.propTypes.string.isRequired,

  /** Specifies the language of the linked document */
  hrefLang: index.propTypes.string,

  /** An object containing the props to be passed down to the Icon component */
  iconProps: index.propTypes.shape({
    name: index.propTypes.string,
    size: index.propTypes.string,
    title: index.propTypes.string
  }),

  /** An i18n key that will be used to search for content */
  intlKey: index.propTypes.string,

  /** An object containing the values to be passed down to the internationalized message */
  intlValues: index.propTypes.shape({}),

  /** Specifies if the styled component should be rendered */
  noStyle: index.propTypes.bool,

  /** Specifies the relationship between the current document and the linked document */
  rel: index.propTypes.oneOf(['', 'alternate', 'author', 'bookmark', 'external', 'help', 'license', 'next', 'nofollow', 'noreferrer', 'noopener', 'prev', 'search', 'tag']),

  /** The target attribute specifies where to open the linked document */
  target: index.propTypes.oneOf(['', '_blank', '_self', '_parent', '_parent', 'framename']),

  /** An object containing the props to be passed down to the Typography component */
  typographyProps: index.propTypes.shape({
    color: index.propTypes.string,
    colorVariant: index.propTypes.string,
    variant: index.propTypes.string
  }),

  /** The font style that will be rendered */
  variant: linkVariantsPropType
};
Link.displayName = 'Link';

exports.colorMapper = colorMapper;
exports.default = Link;
exports.linkColorsPropType = linkColorsPropType;
exports.linkVariantsPropType = linkVariantsPropType;
exports.variantMapper = variantMapper;
//# sourceMappingURL=Link.js.map
